/**
 * Passkey client entry point.
 *
 * Exposes the Laravel passkeys client as a global, the same way the previous
 * Webpass CDN script did, so the Blade views can keep their inline handlers
 * (which need translated strings from the server).
 */

import { Passkeys } from '@laravel/passkeys';

declare global {
    interface Window {
        Passkeys: typeof Passkeys;
        passkeyNeedsPasswordConfirmation: (error: unknown) => boolean;
    }
}

/**
 * The passkey management routes sit behind Laravel's `password.confirm`
 * middleware, which answers XHR requests with a 423 and the message below.
 * The client surfaces that as a plain Error, so this is how we detect it.
 */
const passkeyNeedsPasswordConfirmation = (error: unknown): boolean => {
    const message = error instanceof Error ? error.message : String(error);

    return message === 'Password confirmation required.' || message.includes('status 423');
};

window.Passkeys = Passkeys;
window.passkeyNeedsPasswordConfirmation = passkeyNeedsPasswordConfirmation;

export { Passkeys, passkeyNeedsPasswordConfirmation };
